import React, { useEffect, useRef, useState } from 'react';
// import { reactPlugin } from '../../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { jsonEditorStyles } from '../jsonEditorStyles';
import Button from '@mui/material/Button';
import useComponentUIHook from './useComponentUIHook';
import { SelectComponent, TextComponent } from '../../uiComponents';
import { Checkbox, FormControlLabel, SelectChangeEvent } from '@mui/material';
import { OptionProps } from '../../../view-models';
import { cloneDeep } from 'lodash';
import SessionManagement, { sessionFieldsAreValid } from './sessionManagement';
import jsonComponents from '../../../constants/jsonComponents';
import TemplatizedFieldComponent, { TemplatizedValue, getTemplatizedValue } from './templatizedFieldComponent';

interface componentProps {
  componentData: any;
  closeGritComponent: any;
  setUnsavedChanges: any;
}
const GenerateMFAAuthUI = ({ componentData, closeGritComponent, setUnsavedChanges }: componentProps) => {
  const { modifiedData, setModifiedData, checkIfSameIgnoringSubFlows, allClaims, modifiedTemplatizations, setModifiedTemplatizations } = useComponentUIHook(componentData);
  const [disableSubmit, setDisableSubmit] = useState<boolean>(false);
  const classes = jsonEditorStyles();
  const configData: any = jsonComponents.mfa;

  useEffect(() => {
    const _res: boolean = checkIfSameIgnoringSubFlows();
    setDisableSubmit(_res || (modifiedData['mode'] === '' ||
      (['newIfNotPresent', 'existingOnly'].includes(modifiedData['mode']) &&
        modifiedData['phoneNumberClaim'] === '') ||
      modifiedData['idClaim'] === '' ||
      modifiedData['enteredPhoneNumberClaim'] === '' ||
      modifiedData['newNumberFlagClaim'] === '') ||
      ((!modifiedData['stepUpEnabled']) && (!sessionFieldsAreValid(modifiedData))));
    setUnsavedChanges(_res);
  }, [modifiedData]);

  return (
    <div className={classes.flexCol}>
      <div className={classes.flexRow}>
          <TemplatizedFieldComponent
            modifiedTemplatizations={modifiedTemplatizations}
            setModifiedTemplatizations={setModifiedTemplatizations}
            data={{
              fieldPath: 'contentDefinition',
              label: configData['contentDefinition']['displayName'],
              style: { margin: 1, width: 600 },
              value: getTemplatizedValue(modifiedData['contentDefinition']),
              variant: 'text'
            }}
            changeHandler={(e: TemplatizedValue) => {
              setModifiedData({ ...modifiedData, contentDefinition: { ...e } });
            }}
          />
        </div>
      <div className={classes.flexRow}>
        <SelectComponent
          changeHandler={(e: SelectChangeEvent<any>) => {
            setModifiedData({
              ...modifiedData,
              mode: e.target.value,
            });
          }}
          data={{
            value: modifiedData['mode'],
            label: 'Phone Number entry mode',
            style: { margin: 1, width: 200 },
            options: Object.keys(configData.mode).reduce(
              (acc: OptionProps[], curVal: string) => acc.concat({ label: configData['mode'][curVal], value: curVal }),
              [],
            ),
            required: true,
          }}
        />
        {['newIfNotPresent', 'existingOnly'].includes(modifiedData['mode']) && (
          <SelectComponent
            changeHandler={(e: SelectChangeEvent<any>) => {
              setModifiedData({
                ...modifiedData,
                phoneNumberClaim: e.target.value,
              });
            }}
            data={{
              value: modifiedData['phoneNumberClaim'],
              label: 'Phone Number claim',
              style: { margin: 1, width: 200 },
              options: Object.keys(allClaims)
                .filter((claim: string) => allClaims[claim].dataType === 'string')
                .reduce((acc: OptionProps[], curVal: any) => acc.concat({ label: curVal, value: curVal }), []),
              required: true,
            }}
          />
        )}
      </div>

      <div className={classes.flexRow}>
        <SelectComponent
          changeHandler={(e: SelectChangeEvent<any>) => {
            setModifiedData({ ...modifiedData, idClaim: e.target.value });
          }}
          data={{
            value: modifiedData['idClaim'],
            label: 'ID Claim',
            style: { margin: 1, width: 200 },
            options: Object.keys(allClaims)
              .filter((claim: string) => allClaims[claim].dataType === 'string')
              .filter((claim: string) => claim !== modifiedData['enteredPhoneNumberClaim'])
              .reduce((acc: OptionProps[], curVal: any) => acc.concat({ label: curVal, value: curVal }), []),
            required: true,
          }}
        />
        <SelectComponent
          changeHandler={(e: SelectChangeEvent<any>) => {
            setModifiedData({ ...modifiedData, enteredPhoneNumberClaim: e.target.value });
          }}
          data={{
            value: modifiedData['enteredPhoneNumberClaim'],
            label: 'Verified Phone Number Claim',
            style: { margin: 1, width: 200 },
            options: Object.keys(allClaims)
              .filter((claim: string) => allClaims[claim].dataType === 'string')
              .filter((claim: string) => claim !== modifiedData['idClaim'])
              .reduce((acc: OptionProps[], curVal: any) => acc.concat({ label: curVal, value: curVal }), []),
            required: true,
          }}
        />
        <SelectComponent
          changeHandler={(e: SelectChangeEvent<any>) => {
            setModifiedData({ ...modifiedData, newNumberFlagClaim: e.target.value });
          }}
          data={{
            value: modifiedData['newNumberFlagClaim'],
            label: 'New Number Flag Claim',
            style: { margin: 1, width: 200 },
            options: Object.keys(allClaims)
              .filter((claim: string) => allClaims[claim].dataType === 'boolean')
              .reduce((acc: OptionProps[], curVal: any) => acc.concat({ label: curVal, value: curVal }), []),
            required: true,
          }}
        />
      </div>
      <FormControlLabel
        sx={{ m: 1 }}
        label="Enable Step-Up MFA"
        control={
          <Checkbox
            checked={modifiedData['stepUpEnabled']}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              if (modifiedData['stepUpEnabled']) {
                setModifiedData({
                  ...modifiedData,
                  stepUpEnabled: !modifiedData['stepUpEnabled'],
                  sessionManagement: modifiedData['altSessionManagement']
                });
              } else {
                setModifiedData({
                  ...modifiedData,
                  stepUpEnabled: !modifiedData['stepUpEnabled'],
                  altSessionManagement: modifiedData['sessionManagement'],
                  sessionManagement: {
                    option: 'skipForSpecificSession',
                    sessionId: '_stepUpMfa'
                  }
                });
              }
            }}
          />
        }
      />
      {configData.sessionManagement && (!modifiedData['stepUpEnabled']) && (
        <SessionManagement
          modifiedData={modifiedData}
          changeHandler={(data: any) => setModifiedData(data)}
          sessionTypes={configData.sessionTypes}
        />
      )}
      <div>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          disabled={disableSubmit}
          sx={{ mt: 3, mb: 2 }}
          onClick={() => {
            closeGritComponent(cloneDeep(modifiedData), modifiedTemplatizations);
          }}
        >
          Save
        </Button>
      </div>
    </div>
  );
};
// export default withAITracking(reactPlugin, GenerateMFAAuthUI);
export default GenerateMFAAuthUI;
